module.exports = __webpack_public_path__ + "img/promo-1.0af7ceb1.png";